// Copied verbatim from original/src/lib/utils.ts:1-19 and :54-60 — digit normalisation and
// thousands separators for text inputs. Display-only; no money arithmetic (ADR-02 §2.9).
export const toEnglishDigits = (str: string) => {
  if (!str) return '';
  const arabicDigits = '٠١٢٣٤٥٦٧٨٩';
  const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
  return str
    .replace(/[٠-٩۰-۹]/g, (d) => {
      const aIdx = arabicDigits.indexOf(d);
      if (aIdx !== -1) return aIdx.toString();
      const pIdx = persianDigits.indexOf(d);
      if (pIdx !== -1) return pIdx.toString();
      return d;
    })
    .replace(/[٫]/g, '.');
};

export const parseCommas = (val: string) => {
  if (!val) return '';
  return val.replace(/[,،]/g, '');
};

export const formatWithCommas = (val: string | number) => {
  if (val === undefined || val === null || val === '') return '';
  const s = val.toString();
  const parts = s.split('.');
  parts[0] = (parts[0] ?? '').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join('.');
};
